import { render, staticRenderFns } from "./stakeholders.vue?vue&type=template&id=7a74b8d1"
import script from "./stakeholders.ts?vue&type=script&lang=js&external"
export * from "./stakeholders.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports